<template>
  <div>
    <v-card class="mx-auto" width="95%">
      <v-card-title>
        <v-toolbar-title>Anúncios da tela principal</v-toolbar-title>
      </v-card-title>
      <v-data-table :headers="columns" :items="anuncios" :items-per-page="5" class="elevation-0">
        <template v-slot:item="row">
          <tr>
            <td>{{ row.item.titulo }}</td>
            <td>{{ row.item.midia.length > 0 ? row.item.midia[0].link_url : ''}}</td>
            <td>
              <v-btn
                x-small
                class="mb-2"
                text
                @click="mostrarImagensAnuncio(row.item)"
                title="Visualizar Imagem"
              >
                <v-icon dark>image</v-icon>
              </v-btn>
              <v-btn x-small class="mb-2" text @click="deletarAnuncio(row.item.id)">
                <v-icon dark>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-toolbar color="darken-1" class="mb-1" elevation="0">
        <v-btn
          dark
          rounded
          color="darken-2"
          class="text-transform-none"
          @click="mostrarNovoAnuncio()"
        >
          <v-icon>add</v-icon>Novo Anuncio
        </v-btn>
      </v-toolbar>
    </v-card>

    <v-dialog v-model="dlgFormAnuncio" transition="dialog-bottom-transition">
      <FormAnuncio
        v-if="dlgFormAnuncio"
        @salvar="salvarAnuncio"
        @fechar="fecharDlgAnuncio"
        :isNovo="isNew"
        :setAnuncio="anuncio"
      />
    </v-dialog>

    <v-dialog v-model="dlgImageAnuncio" transition="dialog-bottom-transition" width="500">
      <v-card v-if="dlgImageAnuncio">
        <v-toolbar dark color="darken-2" elevation="0" @short="true">
          <v-btn icon dark @click="fecharDlgImagemAnuncio()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <span>Visualizar Imagens</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-carousel cycle hide-delimiter-background show-arrows-on-hover style="margin-top: 25px">
            <v-carousel-item v-for="(image, i) in anuncioImagens" :key="i">
              <v-img :src="image" aspect-ratio="1" contain />
            </v-carousel-item>
          </v-carousel>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FormAnuncio from "@/views/publicacao/FormAnuncio.vue";
import PublicacaService from "@/services/publicacaoService.js";
import AnuncioInput from "@/classes/anuncioInput.js";
export default {
  data() {
    return {
      columns: [
        { text: "Anunciante", align: "center" },
        { text: "Link", align: "center" },
        { text: "" },
      ],
      rules: [
        (value) =>
          !value ||
          value.size < 2000000 ||
          "Imagem não pode ser maior que 2 MB!",
      ],
      anuncios: [],
      anuncioImagens: [],
      isNew: true,
      dlgFormAnuncio: false,
      dlgImageAnuncio: false,
      anuncio: new AnuncioInput(),
      fotoUpload: null,
    };
  },
  methods: {
    mostrarNovoAnuncio() {
      this.isNew = true;
      this.anuncio = new AnuncioInput();
      this.fotoUpload = null;
      this.dlgFormAnuncio = true;
    },
    salvarAnuncio(value) {
      this.anuncio = value;
      if (this.isNew) {
        PublicacaService.criarAnuncioPrincipal(this.anuncio).then(
          async (result) => {
            if (result.data.errors) {
              this.$toast.error(result.data.errors);
            } else {
              this.$toast.info("Anúncio salva com sucesso.");
              await this.carregarAnuncios();
              this.dlgFormAnuncio = false;
            }
          }
        );
      }
    },
    mostrarImagensAnuncio(anuncio) {
      this.anuncioImagens = [];
      for (var i = 0; i < anuncio.midia.length; i++) {
        const midia = anuncio.midia[i];
        for (var j = 0; j < midia.imagem.length; j++) {
          const imagem = midia.imagem[j];
          if (this.$utils.isNotNull(imagem)) {
            this.anuncioImagens.push(imagem);
          }
        }
      }
      this.dlgImageAnuncio = true;
    },
    async deletarAnuncio(publicacaoId) {
      var result = await PublicacaService.deletarPublicacao(publicacaoId);
      if (result.data.errors) {
        this.$toast.error("Não é possivel remover o anúncio.");
      } else {
        this.$toast.info("Anúncio removido com sucesso.");
        await this.carregarAnuncios();
      }
    },
    async carregarAnuncios() {
      var result = await PublicacaService.listarAnuncioSemEditorial();
      console.log(result);
      this.anuncios = result.data.data.listarAnuncioSemEditorial;
    },
    fecharDlgImagemAnuncio() {
      this.dlgImageAnuncio = false;
    },
    fecharDlgAnuncio() {
      this.dlgFormAnuncio = false;
    },
  },
  updated() {},
  created() {
    this.carregarAnuncios();
  },
  components: {
    FormAnuncio,
  },
};
</script>
<style></style>
